import React from 'react'

export default function NewsletterPage(){

  return <div>
    <h3>Newsletter</h3>
  </div>
}